// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__xFhcM","title":"Modal_title__nj9Qg","content":"Modal_content__wKpTf","actions":"Modal_actions__Tib5F"};